class CosumyBonusTeaser {
  constructor(element) {
    this.element = element;
    this.subtextElement = element.querySelector('.cosumy-bonus-teaser__subtext');
    this.imageContainer = element.querySelector('#milk-jug-image-container');
    
    this.shippingThreshold = 3900; // 39€ in cents
    this.giftThreshold = 7900; // 79€ in cents
    this.imageLoaded = false;
    this.productImageUrl = null;
    
    this.init();
  }

  init() {
    this.updateTeaser();
    
    // Listen for cart updates
    document.addEventListener('cart:updated', () => {
      setTimeout(() => this.updateTeaser(), 100);
    });
    
    document.addEventListener('cart:change', () => {
      setTimeout(() => this.updateTeaser(), 100);
    });
  }

  getCurrentCartTotal() {
    // Try multiple methods to get cart total
    const teaserTotal = this.element.dataset.cartTotal;
    if (teaserTotal) {
      return parseInt(teaserTotal) || 0;
    }
    
    const progressBar = document.querySelector('.cosumy-progressbar');
    if (progressBar && progressBar.dataset.cartTotal) {
      return parseInt(progressBar.dataset.cartTotal) || 0;
    }
    
    if (window.cart && window.cart.total_price) {
      return window.cart.total_price;
    }
    
    return 0;
  }

  checkIfGiftInCart() {
    // Check if gift is already in cart by looking at DOM
    const cartItems = document.querySelectorAll('.cart-item');
    let hasGift = false;
    
    cartItems.forEach(item => {
      // Check for SKU in product title or properties
      const productTitle = item.querySelector('.cart-item__name');
      const properties = item.querySelectorAll('.product-option');
      
      if (productTitle && productTitle.textContent.toLowerCase().includes('milch')) {
        // Additional check for 350ml or similar
        if (productTitle.textContent.includes('350')) {
          hasGift = true;
        }
      }
      
      // Check properties for gift marker
      properties.forEach(prop => {
        if (prop.textContent.includes('Geschenk') || prop.textContent.includes('_gift')) {
          hasGift = true;
        }
      });
    });
    
    // Also check data attribute from Liquid
    const hasGiftFromLiquid = this.element.dataset.hasGift === 'true';
    
    return hasGift || hasGiftFromLiquid;
  }

  updateTeaser() {
    const cartTotal = this.getCurrentCartTotal();
    
    // Check if gift is already in cart
    const hasGift = this.checkIfGiftInCart();
    
    // Check if teaser should be visible
    if (cartTotal < this.shippingThreshold || cartTotal >= this.giftThreshold || hasGift) {
      this.hideTeaser();
      return;
    }
    
    // Update text
    const remaining = this.giftThreshold - cartTotal;
    const remainingFormatted = this.formatPrice(remaining);
    const newText = `Erhalte unsere 350 ml <strong>Milchkännchen</strong> als Geschenk – nur noch <strong>${remainingFormatted}</strong> entfernt`;
    
    if (this.subtextElement.innerHTML !== newText) {
      this.subtextElement.style.opacity = '0.7';
      setTimeout(() => {
        this.subtextElement.innerHTML = newText;
        this.subtextElement.style.opacity = '1';
      }, 150);
    }
    
    // Image is now static - no dynamic loading needed
    
    // Show teaser if hidden
    this.showTeaser();
  }

  async tryLoadRealProductImage() {
    const imageContainer = this.element.querySelector('#milk-jug-image-container');
    const placeholder = imageContainer.querySelector('.js-milk-jug-placeholder');
    const hasRealImage = imageContainer.querySelector('img');
    
    // If real image already exists, skip
    if (hasRealImage) {
      return;
    }
    
    console.log('Trying to load real milk jug product image...');
    
    try {
      // Method 1: Try direct product handles
      const possibleHandles = [
        'milchkanne-350ml',
        'milchkanne-350-ml',
        'milchkanne',
        'milchkaennchen-350ml',
        'milchkaennchen',
        'milk-jug-350ml',
        'cosumy-milchkanne'
      ];
      
      for (const handle of possibleHandles) {
        try {
          const response = await fetch(`/products/${handle}.js`);
          if (response.ok) {
            const product = await response.json();
            if (product.images && product.images.length > 0) {
              console.log(`Found product by handle: ${handle} - ${product.title}`);
              this.loadProductImage(product, placeholder);
              return;
            }
          }
        } catch (e) {
          // Continue to next handle
        }
      }
      
      // Method 2: Search through all products
      const response = await fetch('/products.json?limit=250');
      const data = await response.json();
      
      console.log(`Searching through ${data.products.length} products...`);
      
      // Search by SKU first (most specific)
      let milkJugProduct = data.products.find(product => {
        const hasSKU = product.variants.some(variant => variant.sku === '7770201');
        if (hasSKU) {
          console.log(`Found product by SKU 7770201: ${product.title}`);
        }
        return hasSKU;
      });
      
      // Search by title with 350ml
      if (!milkJugProduct) {
        milkJugProduct = data.products.find(product => {
          const title = product.title.toLowerCase();
          const match = title.includes('milch') && title.includes('350');
          if (match) {
            console.log(`Found product by title (milch + 350): ${product.title}`);
          }
          return match;
        });
      }
      
      // Search by title with "kanne" or "kännchen"
      if (!milkJugProduct) {
        milkJugProduct = data.products.find(product => {
          const title = product.title.toLowerCase();
          const match = title.includes('milch') && (title.includes('kanne') || title.includes('kännchen'));
          if (match) {
            console.log(`Found product by title (milch + kanne): ${product.title}`);
          }
          return match;
        });
      }
      
      // Any product with "milch" (broadest search)
      if (!milkJugProduct) {
        milkJugProduct = data.products.find(product => {
          const title = product.title.toLowerCase();
          const match = title.includes('milch');
          if (match) {
            console.log(`Found product by title (milch): ${product.title}`);
          }
          return match;
        });
      }
      
      if (milkJugProduct && milkJugProduct.images && milkJugProduct.images.length > 0) {
        this.loadProductImage(milkJugProduct, placeholder);
      } else {
        console.log('No milk jug product found in any search method');
        console.log('Available products:', data.products.map(p => p.title).slice(0, 10));
      }
    } catch (error) {
      console.log('Error fetching products:', error);
    }
  }

  loadProductImage(product, placeholder) {
    const imageUrl = product.images[0].src || product.images[0];
    const img = document.createElement('img');
    
    img.src = imageUrl + '?width=96';
    img.alt = product.title;
    img.width = 48;
    img.height = 48;
    img.style.cssText = 'object-fit: contain; border-radius: 8px; opacity: 0; transition: opacity 300ms ease;';
    img.loading = 'eager';
    
    img.onload = () => {
      console.log(`Successfully loaded milk jug image: ${product.title}`);
      if (placeholder) {
        placeholder.style.opacity = '0';
        setTimeout(() => {
          placeholder.style.display = 'none';
          this.element.querySelector('#milk-jug-image-container').appendChild(img);
          img.style.opacity = '1';
        }, 200);
      } else {
        this.element.querySelector('#milk-jug-image-container').appendChild(img);
        img.style.opacity = '1';
      }
    };
    
    img.onerror = () => {
      console.log(`Failed to load image from: ${imageUrl}`);
    };
  }

  async loadProductImage() {
    // Check global cache first
    if (window.cosumyMilkJugImageCache.loaded) {
      this.productImageUrl = window.cosumyMilkJugImageCache.imageUrl;
      this.productTitle = window.cosumyMilkJugImageCache.title;
      this.imageLoaded = true;
      this.restoreProductImage();
      return;
    }
    
    // If image is currently loading, skip
    if (this.imageContainer.querySelector('img')) {
      return;
    }
    
    try {
      // Try multiple approaches to find the product
      let milkJugProduct = null;
      
      // Method 1: Try direct product fetch by handle
      const possibleHandles = [
        'milchkanne-350ml',
        'milchkanne-350-ml', 
        'milchkanne',
        'milk-jug-350ml',
        'cosumy-milchkanne',
        'milchkaennchen-350ml'
      ];
      
      for (const handle of possibleHandles) {
        try {
          const response = await fetch(`/products/${handle}.js`);
          if (response.ok) {
            milkJugProduct = await response.json();
            console.log(`Found product by handle: ${handle}`);
            break;
          }
        } catch (e) {
          // Continue to next handle
        }
      }
      
      // Method 2: Search through products.json
      if (!milkJugProduct) {
        const response = await fetch('/products.json?limit=250');
        const data = await response.json();
        
        milkJugProduct = data.products.find(product => {
          // Check by SKU first
          const hasSKU = product.variants.some(variant => variant.sku === '7770201');
          if (hasSKU) {
            console.log(`Found product by SKU: ${product.title}`);
            return true;
          }
          
          // Check by title keywords
          const title = product.title.toLowerCase();
          if (title.includes('milch') && (title.includes('350') || title.includes('kanne'))) {
            console.log(`Found product by title: ${product.title}`);
            return true;
          }
          
          return false;
        });
      }
      
      // Load the image if product found
      if (milkJugProduct && milkJugProduct.images && milkJugProduct.images.length > 0) {
        const imageUrl = milkJugProduct.images[0].src || milkJugProduct.images[0];
        this.productImageUrl = imageUrl + '?width=96';
        this.productTitle = milkJugProduct.title;
        
        const img = document.createElement('img');
        img.src = this.productImageUrl;
        img.alt = this.productTitle;
        img.width = 48;
        img.height = 48;
        img.style.cssText = 'object-fit: contain; border-radius: 8px; opacity: 0; transition: opacity 300ms ease;';
        img.loading = 'eager';
        
        img.onload = () => {
          this.imageLoaded = true;
          
          // Cache globally for all instances
          window.cosumyMilkJugImageCache = {
            loaded: true,
            imageUrl: this.productImageUrl,
            title: this.productTitle
          };
          
          const placeholder = this.imageContainer.querySelector('.milk-jug-placeholder');
          
          if (placeholder) {
            placeholder.style.opacity = '0';
            setTimeout(() => {
              placeholder.style.display = 'none';
              this.imageContainer.appendChild(img);
              img.style.opacity = '1';
            }, 200);
          } else {
            this.imageContainer.appendChild(img);
            img.style.opacity = '1';
          }
        };
        
        img.onerror = () => {
          console.log('Failed to load milk jug image from:', imageUrl);
        };
      } else {
        console.log('No milk jug product found');
      }
    } catch (error) {
      console.log('Could not fetch product data:', error);
    }
  }

  restoreProductImage() {
    // Remove any existing images
    const existingImg = this.imageContainer.querySelector('img');
    if (existingImg) {
      return; // Image already there
    }
    
    // Hide placeholder and show cached image
    const placeholder = this.imageContainer.querySelector('.milk-jug-placeholder');
    if (placeholder) {
      placeholder.style.display = 'none';
    }
    
    const img = document.createElement('img');
    img.src = this.productImageUrl;
    img.alt = this.productTitle;
    img.width = 48;
    img.height = 48;
    img.style.cssText = 'object-fit: contain; border-radius: 8px; opacity: 1; transition: opacity 300ms ease;';
    img.loading = 'eager';
    
    this.imageContainer.appendChild(img);
  }

  showTeaser() {
    if (this.element.style.display === 'none') {
      this.element.style.display = 'block';
      // Trigger reflow for animation
      this.element.offsetHeight;
      this.element.style.opacity = '0';
      this.element.style.transform = 'translateY(8px)';
      
      setTimeout(() => {
        this.element.style.transition = 'opacity 400ms ease-out, transform 400ms ease-out';
        this.element.style.opacity = '1';
        this.element.style.transform = 'translateY(0)';
      }, 10);
    }
  }

  hideTeaser() {
    if (this.element.style.display !== 'none') {
      this.element.style.transition = 'opacity 300ms ease-out, transform 300ms ease-out';
      this.element.style.opacity = '0';
      this.element.style.transform = 'translateY(-8px)';
      
      setTimeout(() => {
        this.element.style.display = 'none';
      }, 300);
    }
  }

  formatPrice(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }
}

// Global teaser instances and image cache
window.cosumyBonusTeasers = [];
window.cosumyMilkJugImageCache = {
  loaded: false,
  imageUrl: null,
  title: null
};

// Initialize teasers when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  initializeBonusTeasers();
});

document.addEventListener('shopify:section:load', function() {
  initializeBonusTeasers();
});

function initializeBonusTeasers() {
  window.cosumyBonusTeasers = [];
  
  const teasers = document.querySelectorAll('.cosumy-bonus-teaser');
  teasers.forEach(teaser => {
    const instance = new CosumyBonusTeaser(teaser);
    window.cosumyBonusTeasers.push(instance);
  });
}

// Global update function
function updateAllBonusTeasers() {
  if (window.cosumyBonusTeasers) {
    window.cosumyBonusTeasers.forEach(teaser => {
      teaser.updateTeaser();
    });
  }
}

// Listen for cart updates
document.addEventListener('cart:updated', updateAllBonusTeasers);
document.addEventListener('cart:change', updateAllBonusTeasers);